import React from 'react';
import { ClipboardListIcon, DownloadIcon } from 'lucide-react';
interface AuditViewProps {
  userPlan: string;
}
export function AuditView({
  userPlan
}: AuditViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-233">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-234">
        <div data-id="element-235">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-236">Audit</h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-237">
            Review system usage and activity logs
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-238">
          <DownloadIcon className="w-4 h-4" data-id="element-239" />
          Export Logs
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-240">
        <ClipboardListIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-241" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-242">Audit Logs</h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-243">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to access audit logs.' : 'Review detailed logs of system activity and user actions.'}
        </p>
      </div>
    </div>;
}